import React, { useEffect, useState } from "react"
import { Popover, PopoverHeader, PopoverBody } from "reactstrap"

export default function OutsideClickPopover({ target, title, body }) {
  const [open, setOpen] = useState(false)
  const toggle = () => setOpen((o) => !o)

  useEffect(() => {
    function handleClick(e) {
      const trigger = document.getElementById(target)

      const clickedInsidePopover = e.target.closest(".popover")
      const clickedTrigger = trigger && trigger.contains(e.target)

      // If it's open and user clicked OUTSIDE popover AND OUTSIDE trigger
      if (open && !clickedInsidePopover && !clickedTrigger) {
        setOpen(false)
      }
    }

    document.addEventListener("mousedown", handleClick)
    return () => document.removeEventListener("mousedown", handleClick)
  }, [open, target])

  return (
    <Popover
      isOpen={open}
      toggle={toggle}
      target={target}
      placement="auto"
      flip
    >
      {title && <PopoverHeader>{title}</PopoverHeader>}
      <PopoverBody>{body}</PopoverBody>
    </Popover>
  )
}
